import { GetterTree } from "vuex";
import { IApprovalWorkflow } from "@/core/interfaces/approvalWorkflow.interface";
import { IApprovalSystemState } from "../types";
import { StoreState } from "@/store/type";

const getters: GetterTree<IApprovalSystemState, StoreState> = {
  approvalWorkflows: (state): IApprovalWorkflow[] =>
    state.approvalWorkflows || [],
  selectedApprovalWorkflow: (state): IApprovalWorkflow | null =>
    state.selectedApprovalWorkflow,
  isFetchingApprovalWorkflows: (state): boolean =>
    state.isFetchingApprovalWorkflows,
  isFetchingApprovalWorkflowDetail: (state): boolean =>
    state.isFetchingApprovalWorkflowDetail,
  approvalWorkflowActionLoading: (state): boolean =>
    state.approvalWorkflowActionLoading,
};

export default getters;
